import { combineEpics } from 'redux-observable'
import ArtworkEpics from 'epics/artworkEpics'
import CuratorEpics from 'epics/ops/curate'
import ScrollEpics from 'epics/utility/scroll'
import AdminEpics from './admin'
import AppEpics from './app'
import SellOutRiskEpics from './sellOutRisk'
import algoliaEpics from './algolia'
const epicList = [
  ...AdminEpics,
  ...AppEpics,
  ...CuratorEpics,
  ...ScrollEpics,
  ...SellOutRiskEpics,
  ...algoliaEpics,
]
export default combineEpics(...ArtworkEpics, ...epicList)
